import styled from 'styled-components';

import { ResourcesNoData } from './ResourcesNoData';

const StyledNoData = styled(ResourcesNoData)`
  max-height: 358px;
`;

export { StyledNoData };
